<template>
  <div>
    <custom-popup
      v-model="dialog"
      :cons="{
        title: 'دستیار هوش مصنوعی طراحی کارت ویزیت',
        icon: 'magic-staff'
      }"
      class="pa-4"
      :loading.sync="loading"
      hide-confirm
      max-width="1100"
      persistent
      scrollable
    >
      <v-card flat class="pa-2">
        <v-card-title class="pa-0 mb-3">
          <v-alert
            border="left"
            color="#007bff"
            colored-border
            elevation="5"
            class="w-100"
          >
            <div class="d-flex align-center">
              <div>
                <div class="text-subtitle-2 font-weight-bold my-2">
                  <v-icon small color="#007bff">mdi-robot-outline</v-icon>
                  طراحی هوشمند کارت ویزیت
                </div>

                <div class="text-caption grey--text text--darken-2">
                  اطلاعات کارت را وارد کنید تا یک طراحی اختصاصی تولید شود.
                </div>
              </div>
            </div>
          </v-alert>
        </v-card-title>

        <div class="d-flex justify-center align-center mb-4 px-2">
          <v-chip 
            class="rounded-lg info--text justify-center"
            color="rgba(0, 123, 255, 0.1)"
            small
            @click="showUpgrade = true"
            style="cursor: pointer;"
          >
            <v-icon left small color="info">
              mdi-creation-outline
            </v-icon>

            <span>
              اعتبار باقی‌مانده AI:
              {{ persian(computedRemainingCount) }} بار
            </span>
          </v-chip>
        </div>

        <v-card-text class="pt-0">
          <div class="text-subtitle-2 font-weight-bold mb-2">
            حالت تولید محتوا:
          </div>

          <v-radio-group
            v-model="aiMode"
            row
            class="mt-0 mb-4"
            hide-details
          >
            <v-radio value="creative" color="primary">
              <template v-slot:label>
                <div class="d-flex flex-column text-right">
                  <span class="font-weight-bold black--text">
                    حالت هوشمند (خلاقانه)
                  </span>

                  <span class="text-caption grey--text">
                    بهبود متن، تکمیل توضیحات و ساخت محتوای حرفه‌ای
                  </span>
                </div>
              </template>
            </v-radio>

            <v-radio value="fixed" color="primary" >
              <template v-slot:label>
                <div class="d-flex flex-column text-right">
                  <span class="font-weight-bold black--text">
                    حالت دقیق (وفادار به متن)
                  </span>

                  <span class="text-caption grey--text">
                    استفاده دقیق از اطلاعات واردشده بدون تولید محتوای جدید
                  </span>
                </div>
              </template>
            </v-radio>
          </v-radio-group>

          <div class="text-subtitle-2 font-weight-bold mb-2 mt-4">
            اطلاعات کارت:
          </div>

          <v-textarea
            v-model="rawInput"
            placeholder="مثال: شرکت طراحی سایت در تهران، شماره تماس 0912..."
            outlined
            rows="6"
            dense
            hide-details
            class="mb-4"
          />

          <div class="d-flex justify-space-between ga-3 mt-4 flex-wrap">
            <v-btn
              class="btn-get-code rounded-lg"
              :loading="generating"
              :disabled="generating"
              @click="processAndGenerate"
            >
              <v-icon left>
                mdi-auto-fix
              </v-icon>

              تولید و اعمال طراحی
            </v-btn>

            <v-btn
              outlined
              class="btn-delete rounded-lg"
              :disabled="generating"
              @click="closeDialog"
            >
              <v-icon left>
                mdi-close
              </v-icon>

              ورود دستی اطلاعات
            </v-btn>
          </div>
        </v-card-text>
      </v-card>
    </custom-popup>
              <togetherAiUpgradeNew
                v-if="showUpgrade"
                v-model="showUpgrade"
                :current-package.sync="currentPackage"
                class="contentinfo"
              />

  </div>
</template>

<script>
import TogetherAiUpgradeNew from "@/view/components/adapters/AIGeneration/togetherAiUpgradeNew.vue";
import MobileViwer from "./components/mobileViwer.vue"; 
import VisitThemeTwo from "./components/themes/visitThemeTwo";
import VisitThemeFlipped from "./components/themes/visitThemeFlipped";

export default {
  name: "AiCardGeneratorDialog",
  components: {
    TogetherAiUpgradeNew,
    MobileViwer,
    VisitThemeTwo,
    VisitThemeFlipped,
  },
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    cardData: {
      type: Object,
      default: () => ({}),
    },
    orders: { type: Array, default: () => [] },
    theme: { type: String, default: null }, 
  },
  data() {
    return {
    dialog: false,
    loading: false,
    generating: false,
    showUpgrade: false,
    currentPackage: {},
    aiMode: "creative",
    rawInput: "",
      showResult: false,
      selectedIndex: 0,
      applyingIndex: null,
      suggestedCards: [],
    };
  },
  watch: {
    value(val) {
      this.dialog = val;
      if (val) {
        this.getPackage();
      }
    },
    dialog(val) {
      this.$emit("input", val);
    },
  },
  computed: {
    computedRemainingCount() {
      if (!this.currentPackage) return 0;
      if (Array.isArray(this.currentPackage.remaining)) {
        return this.currentPackage.remaining.reduce(
          (acc, cur) => acc + Number(cur.remaining || 0),
          0
        );
      }
      return this.currentPackage.remaining || 0;
    },
  },
  methods: {
    isValidHexColor(value) {
  return (
    typeof value === "string" &&
    /^#[0-9a-fA-F]{6}$/.test(value)
  );
},

normalizePalette(aiPalette = {}, basePalette = {}) {
  const fallback = {
    headColor: "#1f2937",
    bodyColor: "#111827",
    textColor: "#ffffff",
    borderColor: "#64748b",
    isDarkBody: true,
  };

  const palette = {
    headColor: this.isValidHexColor(aiPalette.headColor)
      ? aiPalette.headColor
      : basePalette.headColor || fallback.headColor,

    bodyColor: this.isValidHexColor(aiPalette.bodyColor)
      ? aiPalette.bodyColor
      : basePalette.bodyColor || fallback.bodyColor,

    textColor: this.isValidHexColor(aiPalette.textColor)
      ? aiPalette.textColor
      : basePalette.textColor || fallback.textColor,

    borderColor: this.isValidHexColor(aiPalette.borderColor)
      ? aiPalette.borderColor
      : basePalette.borderColor || fallback.borderColor,
  };

  return {
    ...palette,
    isDarkBody:
      typeof aiPalette.isDarkBody === "boolean"
        ? aiPalette.isDarkBody
        : basePalette.isDarkBody ?? fallback.isDarkBody,
  };
},

    header() {
      const token = localStorage.getItem("id_token");
      return {
        Authorization: token ? `Bearer ${token}` : null,
        Accept: "application/json",
        "Content-Type": "application/json",
      };
    },

    getPackage() {
      this.$api
        .get(this.$aiApi + "/packages/user/package")
        .then((res) => {
          this.currentPackage = res.data?.data || {};
        })
        .catch((err) => {
          console.error("خطا در دریافت پکیج:", err);
        });
    },

    persian(str) {
      if (str === null || str === undefined) return "";
      const pNumbers = ["۰", "۱", "۲", "۳", "۴", "۵", "۶", "۷", "۸", "۹"];
      return str.toString().replace(/[0-9]/g, (w) => pNumbers[+w]);
    },

    closeDialog() {
      this.dialog = false;
      this.showResult = false;
      this.generating = false;
    },

    async processAndGenerate() {
 if (
    !this.rawInput &&
    !this.cardData?.organizationName &&
    !this.cardData?.userName
  ) {
    this.$toast?.warning(
      "لطفاً ابتدا اطلاعات کسب‌وکار یا اطلاعات کارت را وارد کنید."
    );

    return;
  }

  if (this.computedRemainingCount <= 0) {
    this.$toast?.warning("اعتبار هوش مصنوعی شما به پایان رسیده است. لطفاً بسته جدید تهیه کنید.");
    this.showUpgrade = true; 
    return;
  }

  this.generating = true;
const modeInstruction =
  this.aiMode === "creative"
    ? `
حالت: خلاقانه
- متن‌ها را حرفه‌ای، جذاب و کامل بنویس.
- aboutUs را در صورت امکان غنی‌تر کن.
- workField و subOrgan را هوشمندانه پر کن.
- اطلاعات واقعی (شماره، آدرس، لینک) را تغییر نده.
`
    : `
حالت: فیکس
- فقط اطلاعات موجود در ورودی را استخراج کن.
- هیچ متن یا اطلاعات جدیدی اضافه نکن.
`;
  const selectedTheme = this.theme || "MobileViwer";

const prompt = `
شما یک دستیار حرفه‌ای طراحی کارت ویزیت دیجیتال هستید.

وظیفه اصلی:
اطلاعات ورودی کاربر را تحلیل کن و یک کارت ویزیت کامل، حرفه‌ای و جذاب به صورت JSON تولید کن.

تم انتخاب‌شده:
${selectedTheme}

اطلاعات ورودی کاربر:
"""
${this.rawInput || "اطلاعاتی وارد نشده"}
"""

اطلاعات فعلی کارت:
${JSON.stringify(this.cardData || {})}

${modeInstruction}

قوانین تولید محتوا:

- فیلدهای organizationName، userName، workField، subOrgan و aboutUs را حتماً پر کن.
- در حالت خلاقانه، متن‌ها را حرفه‌ای، روان و جذاب بنویس (مخصوصاً aboutUs).
- اطلاعات واقعی مثل شماره تلفن، آدرس، ایمیل، اینستاگرام و لینک‌ها را تغییر نده.
- اگر اطلاعاتی ناقص بود، فقط در حالت خلاقانه آن را هوشمندانه تکمیل کن.

قوانین استخراج:

۱. تمام شماره‌های موبایل را در mobiles قرار بده.
۲. تمام شماره‌های ثابت را در landlines قرار بده.
۳. آدرس، ساعت کاری، خدمات، تخصص و اطلاعات جانبی را در extraFields قرار بده.
۴. برای هر extraField فقط از ساختار icon، name و value استفاده کن.
۵. حداکثر ۶ مورد در extraFields قرار بده.
۶. اینستاگرام را بدون @ در instagramId قرار بده.
۷. ایمیل را در email قرار بده.
۸. تلگرام را در telegramId قرار بده.

قوانین رنگ‌بندی (خیلی مهم):

- رنگ‌بندی باید خلاقانه و متناسب با نوع کسب‌وکار و حس برند باشد.
- اگر کاربر رنگ خاصی گفته (آبی، سبز، طلایی، مشکی، قرمز و...)، همان رنگ را رنگ اصلی پالت قرار بده و بقیه رنگ‌ها را هماهنگ بساز.
- اگر رنگی نگفته، بر اساس حوزه کسب‌وکار یک پالت مناسب و حرفه‌ای انتخاب کن.
- کنتراست بین textColor و bodyColor باید بالا باشد تا متن خوانا باشد.
- تمام رنگ‌ها فقط HEX شش‌رقمی باشند.
- مقدار isDarkBody را بر اساس تیرگی bodyColor مشخص کن.

قوانین کلی:

- تم را تغییر نده.
- خروجی فقط JSON معتبر باشد. هیچ متن اضافی، توضیح یا Markdown ننویس.

ساختار دقیق خروجی:

{
  "styleTitle": "عنوان کوتاه و حرفه‌ای طراحی",
  "organizationName": "",
  "userName": "",
  "workField": "",
  "subOrgan": "",
  "aboutUs": "",
  "website": "",
  "instagramId": "",
  "telegramId": "",
  "email": "",
  "mobiles": [],
  "landlines": [],
  "pallete": {
    "headColor": "#1f2937",
    "bodyColor": "#111827",
    "textColor": "#ffffff",
    "borderColor": "#64748b",
    "isDarkBody": true
  },
  "extraFields": [
    {
      "icon": "mdi-map-marker",
      "name": "آدرس",
      "value": ""
    }
  ]
}
`;
  try {
    const { data } = await this.$api.post(
      this.$aiApi + "/chat/tmp/chat",
      {
        model: "gpt-4o-mini",
        message: prompt,
        temperature: 0.7,
        max_tokens: 2500,
      },
      {
        headers: this.header(),
      }
    );

    const finishReason = data?.choices?.[0]?.finish_reason;

    if (finishReason === "length") {
      throw new Error("پاسخ هوش مصنوعی ناقص و به دلیل محدودیت توکن قطع شد.");
    }

    const rawContent =
      data?.choices?.[0]?.message?.content ||
      data?.text ||
      "";

    const jsonString = this.extractJsonObject(rawContent);
    const generatedCard = JSON.parse(jsonString);

    if (
      !generatedCard ||
      typeof generatedCard !== "object" ||
      Array.isArray(generatedCard)
    ) {
      throw new Error("ساختار کارت تولیدشده معتبر نیست.");
    }

    const finalCard = this.mergeWithInputJson(generatedCard);

    if (data.package) {
      this.currentPackage = data.package;
    }

    // ارسال مستقیم کارت به کامپوننت والد
this.$emit("apply", {
  data: {
    theme: this.theme || "MobileViwer",
    orders: this.orders || [],
    cardTexts: finalCard,
  },
  saveFinal: false,
});
    this.$toast?.success("طراحی کارت با موفقیت تولید و اعمال شد.");

    this.closeDialog();
  } catch (err) {
    console.error("AI Generation Error:", err);

    if (err.response?.status === 404) {
      this.$toast?.error(
        "اعتبار پکیج هوش مصنوعی شما به پایان رسیده است."
      );

      this.showUpgrade = true;
    } else {
      this.$toast?.error(
        err.message ||
        "خطا در پردازش اطلاعات. لطفاً دوباره تلاش کنید."
      );
    }
  } finally {
    this.generating = false;
  }
},

extractJsonObject(content) {
  const text = String(content || "").trim();

  const firstBrace = text.indexOf("{");
  const lastBrace = text.lastIndexOf("}");

  if (firstBrace === -1 || lastBrace === -1) {
    throw new Error("آبجکت JSON در پاسخ هوش مصنوعی یافت نشد.");
  }

  return text.substring(firstBrace, lastBrace + 1);
},

mergeWithInputJson(aiItem) {
  const baseCard = JSON.parse(
    JSON.stringify(this.cardData || {})
  );

  // تم فقط از prop دریافت می‌شود
  const assignedTheme = this.theme || "MobileViwer";

  let processedPhoneNumbers = [];
  let whatsappLinks = [];

  const hasAiMobiles =
    Array.isArray(aiItem.mobiles) &&
    aiItem.mobiles.length > 0;

  const hasAiLandlines =
    Array.isArray(aiItem.landlines) &&
    aiItem.landlines.length > 0;

  if (hasAiMobiles || hasAiLandlines) {
    if (hasAiMobiles) {
      aiItem.mobiles.forEach((mob, idx) => {
        if (!mob) return;

        processedPhoneNumbers.push({
          name: `موبایل ${idx > 0 ? idx + 1 : ""}`.trim(),
          number: mob,
        });

        let cleaned = String(mob).replace(/\D/g, "");

        if (cleaned.startsWith("98")) {
          cleaned = cleaned.substring(2);
        }

        if (cleaned.startsWith("0")) {
          cleaned = cleaned.substring(1);
        }

        if (cleaned) {
          const waNumber = "+98" + cleaned;

          whatsappLinks.push({
            label: "واتساپ",
            text: waNumber,
            hint: waNumber,
            pattern: "https://wa.me/",
            prefix: "mdi-phone",
            url: waNumber,
            img: "/media/socialIcon/40icon/whatsapp.svg",
            svg: "svgWhatsapp",
          });
        }
      });
    }

    if (hasAiLandlines) {
      aiItem.landlines.forEach((tel, idx) => {
        if (!tel) return;

        processedPhoneNumbers.push({
          name: `تلفن ثابت ${idx > 0 ? idx + 1 : ""}`.trim(),
          number: tel,
        });
      });
    }
  } else {
    processedPhoneNumbers = baseCard.phoneNumber || [];

    whatsappLinks =
      baseCard.socialMedia?.whatsapp || [];
  }

  const instagramRaw =
    aiItem.instagramId ||
    baseCard.socialMedia?.instagram?.[0]?.url ||
    "";

  const telegramRaw =
    aiItem.telegramId ||
    baseCard.socialMedia?.telegram?.[0]?.url ||
    "";

  const emailRaw =
    aiItem.email ||
    baseCard.socialMedia?.email?.[0]?.url ||
    "";

  const mergedPallete = this.normalizePalette(
    aiItem.pallete,
    baseCard.pallete
  );

  return {
    ...baseCard,
    theme: assignedTheme,
    orders: this.orders || [],
    isGradient: false,

    styleTitle:
      aiItem.styleTitle ||
      baseCard.styleTitle ||
      "طراحی هوشمند",

    organizationName:
      aiItem.organizationName ||
      baseCard.organizationName ||
      "",

    userName:
      aiItem.userName ||
      baseCard.userName ||
      "",

    workField:
      aiItem.workField ||
      baseCard.workField ||
      "",

    subOrgan:
      aiItem.subOrgan ||
      baseCard.subOrgan ||
      "",

    aboutUs:
      aiItem.aboutUs ||
      baseCard.aboutUs ||
      "",

    website:
      aiItem.website ||
      baseCard.website ||
      "",

    phoneNumber: processedPhoneNumbers,

    pallete: mergedPallete,

    extraFields:
      Array.isArray(aiItem.extraFields) &&
      aiItem.extraFields.length
        ? aiItem.extraFields
        : baseCard.extraFields || [],

    socialMedia: {
      ...(baseCard.socialMedia || {}),

      ...(whatsappLinks.length
        ? { whatsapp: whatsappLinks }
        : {}),

      ...(instagramRaw
        ? {
            instagram: [
              {
                label: "اینستاگرام",
                text: instagramRaw,
                hint: instagramRaw,
                pattern: "https://instagram.com/",
                prefix: "@",
                url: String(instagramRaw)
                  .replace("https://instagram.com/", "")
                  .replace("@", ""),
                img: "/media/socialIcon/40icon/instagram.svg",
                svg: "svgInstagram",
              },
            ],
          }
        : {}),

      ...(telegramRaw
        ? {
            telegram: [
              {
                label: "تلگرام",
                text: telegramRaw,
                hint: telegramRaw,
                pattern: "https://t.me/",
                prefix: "@",
                url: String(telegramRaw)
                  .replace("https://t.me/", "")
                  .replace("@", ""),
                img: "/media/socialIcon/40icon/telegram.svg",
                svg: "svgTelegram",
              },
            ],
          }
        : {}),

      ...(emailRaw
        ? {
            email: [
              {
                label: "ایمیل",
                text: emailRaw,
                hint: emailRaw,
                pattern: "mailto:",
                prefix: "",
                url: emailRaw,
                img: "/media/socialIcon/40icon/email.svg",
                svg: "svgEmail",
              },
            ],
          }
        : {}),
    },
  };
},

    // applyCard(card, index, shouldSaveFinal = false) {
    //   this.applyingIndex = index;
    //   const finalJson = JSON.parse(JSON.stringify(card));
    //   delete finalJson.styleTitle;
    //   delete finalJson.instagramId;

    //     this.$emit("apply", {
    //       data: {
    //         theme: this.theme || "MobileViwer",
    //         orders: this.orders || [],
    //         cardTexts: finalCard,
    //       },
    //       saveFinal: false,
    //     });

    //   this.$toast.success("طرح کارت با موفقیت اعمال شد.");
    //   this.closeDialog();
    //   this.applyingIndex = null;
    // },
  },
};
</script>

<style scoped>
.card-preview-box {
  cursor: pointer;
  transition: all 0.25s ease;
  height: 520px; /* ارتفاع متناسب برای جا دادن مینیاتور */
  border: 2px solid transparent;
}

.card-preview-box:hover {
  transform: translateY(-4px);
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.15) !important;
}

.selected-card-border {
  border: 2px solid #007bff !important;
}

.real-theme-wrapper {
  height: 400px;
  overflow: hidden; /* حذف اسکرول بار اضافی */
  background: #f8f9fa;
  position: relative;
  display: flex;
  justify-content: center;
}

.theme-scaler {
  width: 375px; /* عرض استاندارد موبایل */
  height: 812px; /* ارتفاع استاندارد موبایل */
  transform: scale(0.48); /* کوچک کردن کارت به ۴۸ درصد سایز اصلی تا کامل دیده شود */
  transform-origin: top center; /* نقطه شروع کوچک شدن از بالا وسط باشد */
  position: absolute;
  top: 10px;
}
</style>
